import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Avatar } from '../../../../CommonComponents/OPL/Avatar/Avatar';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { useIsMobile } from '../../../../_hooks/useIsMobile';
import { Header } from '../../Output.styles';
import { getGradientColoursByScore } from '../../../utils/getGradientColoursByScore';

interface CompatibilityHeaderProps {
  compatibilityScore: number;
  compatibilityStatus: string;
  primaryRespondentInitials: string;
  secondaryRespondentInitials: string;
}

export const CompatibilityHeader = ({
  compatibilityScore,
  compatibilityStatus,
  primaryRespondentInitials,
  secondaryRespondentInitials,
}: CompatibilityHeaderProps) => {
  const isMobile = useIsMobile();

  const colors = getGradientColoursByScore(compatibilityScore);

  return (
    <Header>
      <Box display="flex" justifyContent="center" mb="24">
        <Avatar
          isAlt
          size="large"
          style={{
            background: `linear-gradient(180deg, ${colors.base} 0%, ${colors.highlight} 100%)`,
          }}
        >
          {primaryRespondentInitials}
        </Avatar>

        <Avatar
          isAlt
          size="large"
          style={{
            marginLeft: -20,
            background: `linear-gradient(180deg, ${colors.base} 0%, ${colors.highlight} 100%)`,
          }}
        >
          {secondaryRespondentInitials}
        </Avatar>
      </Box>

      <Text
        as="h1"
        fontSize={isMobile ? 'h2' : 'xl'}
        fontWeight={600}
        mb="24"
        css={`
          line-height: ${isMobile ? '40px' : '56px'};
        `}
      >
        {compatibilityStatus}.
      </Text>
    </Header>
  );
};
